<template>
  <div class="py-2">
    <b-link v-b-toggle="chap.key" class="chap"><b-img :src="require('@/assets/images/arrow-right.svg')"></b-img> {{ chap.key }} </b-link>
    <!-- Element to collapse -->
    <b-collapse :id="chap.key">
      <div v-for="(item, key, i) in chap.item" :key="i">
        <b-link :to="{name: 'hsTwos', params: {two: key}}" class="text-dark category"><b><u>{{ key }}</u></b> <span class="item">{{ item }}</span></b-link>
      </div>
    </b-collapse>

  </div>
</template>
<script>
export default {
  props: ['chap']
}
</script>

<style lang="scss" scoped>

.chap {
  text-transform: capitalize;
  font-size: 1rem;
  font-family: $headings-font-family;
  color: $secondary;
  font-weight: 500;
  display: flex;
  align-items: center;
  text-decoration: none;
  img {
    width: 10px;
    margin-right: 1rem;
    transition: transform .2s;
    transform: rotate(90deg);
  }
  &.collapsed {
    img {
      transform: rotate(0deg);
    }
  }
}
.category {
  display: flex;
  margin-left: 2rem;
  margin-top: 0.5rem;
  text-decoration: none;
  .item {
    font-family: $headings-font-family;
    margin-left: 0.5rem;
    position: relative;
    margin-top: 1px;
  }
}
</style>
